import { computed, unref, type MaybeRef } from 'vue';
import type { ExtendedISbStoryData } from '~/types/storyblokApi';
import { getRoleAccessStatus, RoleAccessStatus } from '~/utils/roleAccess';

type StoryRolesAuthStory = ConfigStoryblok | ExtendedISbStoryData<ConfigStoryblok> | null | undefined;

export function useStoryRolesAuth(story?: MaybeRef<StoryRolesAuthStory>) {
    const { auth } = useLoginState();

    const status = computed<RoleAccessStatus>(() => {
        const s = unref(story);
        return getRoleAccessStatus(s?.content?.rolesWithAccess, auth.value);
    });

    return {
        isAuthenticated: computed(() => status.value === RoleAccessStatus.Allowed),
        status,
        needsLogin: computed(() => status.value === RoleAccessStatus.NeedsLogin),
        isForbidden: computed(() => status.value === RoleAccessStatus.Forbidden)
    };
}
